define('modules/includes_editor/views/list_item_editable',['require','exports','module','base/itemview','ldsh!../templates/list_item_editable'],function(require, exports, module){
  "use strict";
  var ItemView = require("base/itemview");
  module.exports = ItemView.extend({
    template: require("ldsh!../templates/list_item_editable"),
    className: "include-editor-item",
    events: {
      "click": "selectItem",
      "click .js-edit": "editItemName",
      "keyup .js-item-name": "onEditingName"
    },
    initialize: function(options){
      this.viewModel = new Backbone.Model({
        editableName: this.model.get("name"),
        validationError: false,
        editItemName: false
      });
      this.editorState = options.parent.editorState;
      this.listenTo(this.editorState, "change:selectedItem", this.onSelectedItemChange);
      this.listenTo(this.model, "change:name", this.onSetName);
      this.listenTo(this.model, "invalid", this.onValidationError);
    },
    selectItem: function(e){
      this.editorState.set("selectedItem", this.model);
    },
    editItemName: function(e){
      var editItemName = this.viewModel.get("editItemName"),
          name = this.model.get("name"),
          itemName = this.$(".js-item-name").val().trim();
      if (editItemName) {
        this.viewModel.set("editableName", itemName, {silent: true});
        if (itemName && itemName !== name) this.model.set("name", itemName, {validate: true});
        else this.onSetName(this.model);
        if (!this.viewModel.get("validationError"))
          this.editorState.trigger("change:selectedItem", this.editorState, this.model);
      } else {
        this.viewModel.set({
          editItemName: true
        });
      }
    },
    onEditingName: function(e) {
      if (e.keyCode === 13) {
        this.editItemName();
      }
    },
    //mark as selected
    onSelectedItemChange: function(model,value){
      this.$el.toggleClass("selected", this.model === value);
      this.onSetName(this.model);
    },
    onSetName: function(model, value) {
      this.viewModel.set({
        editableName: model.get("name"),
        validationError: false,
        editItemName: false
      });
    },
    onValidationError: function(){
      this.viewModel.set({
        validationError: true,
        editItemName: true
      });
    },
    onRender: function(){
      this.$el.toggleClass("renaming-item", this.viewModel.get("editItemName"));
      this.$el.toggleClass("item-error", this.viewModel.get("validationError"));
    }
  });
});

